import {ImagebProcesser} from "../process";
import {InputImage, ProcessedImage, ProcessedResult} from "../../types";
import {ImagebTool} from "../../tools";

export class ReverseColorImage extends ImagebProcesser {

  _processer?: ImagebProcesser;

  constructor(options?: {
    _processer?: ImagebProcesser,

  }) {
    super();
    this._processer = options?._processer;
  }

  process(input: InputImage): ProcessedResult {
    let result = ImagebTool.invertBitmap(input);
    if (this._processer == null) {
      return new ProcessedResult({
        origin: input,
        result: new ProcessedImage({data: result, width: result.width, height: result.height})
      })
    }
    return this._processer.process(result);
  }
}

